module.exports = __webpack_public_path__ + "img/test_cat_middle.17cc1c44.png";